<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Usługi</span>
        <h3 class="page-title">Lista usług</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button theme="success"
                  @click.prevent="$router.push('/usługi/dodaj')">
          <i class="material-icons">add</i>
          Dodaj usługę
        </d-button>
      </d-col>
    </d-row>
    <d-row
      v-if="loaded"
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="users-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj nazwę usługi"
          v-model="filters.search" />
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>
        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">Usługa</th>
          <th scope="col" class="border-0">Kategoria</th>
          <th scope="col" class="border-0">Akcje</th>
        </tr>
        </thead>
        <tbody v-if="loaded">
        <tr
          v-for="(service, index) of services"
          :key="'user-' + index">
          <td class="align-middle">
            {{ service.name }}
          </td>
          <td class="align-middle">
            {{ service.category_name }}
          </td>
          <td
            class="align-middle"
            style="width: 150px;">
            <d-button
              theme="primary"
              @click.prevent="$router.push('/usługi/edycja/' + service.id)"
              class="mr-2"
              title="Edytuj">
              <i class="material-icons">edit</i>
            </d-button>
            <d-button
              theme="danger"
              :disabled="removeInProgress"
              @click.prevent="removeOffice(service.id)"
              title="Usuń">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
        </tr>
        <tr v-if="services.length === 0">
          <td
            colspan="5"
            class="text-center">
            Brak usług do wyświetlenia&hellip;
          </td>
        </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';

export default {
  name: 'offices',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data() {
    return {
      services: [],
      categories: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
      filters: {
        search: '',
        category_id: '',
      }
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    loadFilteredData () {
      let where = {
        search: this.filters.search,
      };
      if (this.filters.category_id !== null && this.filters.category_id) {
        where.category_id = this.filters.category_id;
      }
      ListUtils.loadItemsData(this, {
        endpoint: '/services/items?page=' + this.currentPage,
        listField: 'services',
        pagination: true,
        params: {
          where
        }
      });
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: ''
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      return this.debouncedLoadFilteredData
    },
    removeOffice (servicesID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/services/delete/',
        id: servicesID,
        successTitle: 'Usunięto usługę',
        successText: 'Wybrana usługa została usunięta',
        confirmTitle: 'Czy na pewno chcesz usunąć tą usługę?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie usługi nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

